import React, { useEffect, useRef } from 'react'
import * as a from '../'
import {useAuth} from '../../../../app/modules/auth'
import {CompanyFields} from '../../../_apiModels/_companyModels'

type Props = {
  formik: any
  settingName: string
  dropdownData: string
  verticalLabel?: boolean
  hideLabel?: boolean
  valueType?: string
  valueDescription?: string
  onChange?: (value: string, index: number) => void

}

export const AncientDropdownSettingField: React.FC<Props> = ({
  settingName,
  dropdownData,
  formik,
  verticalLabel,
  hideLabel,
  valueType,
  valueDescription,
  onChange,
  }) => {
  const {currentInstanceSettings} = useAuth()
    const previousValueRef = useRef<any>(undefined);


    useEffect(() => {
        const index = formik.values.companyFields?.findIndex(
            (field: any) => field.settingName === settingName
        );

        if (index !== -1) {
            const fieldValue = formik.values.companyFields[index]?.fieldValue;

            // Only trigger onChange if the value has actually changed
            if (fieldValue !== undefined &&
                onChange &&
                previousValueRef.current !== fieldValue) {
                previousValueRef.current = fieldValue;
                onChange(fieldValue, index);
            }
        }
    }, [formik.values.companyFields, settingName, onChange]);



    const dropdown = (dropdownDataList: any, index: number) => {

      return (
      <select
        className='form-select form-select-solid fw-bolder'
        data-placeholder='Select option'
        {...formik.getFieldProps('companyFields[' + index + '].fieldValue')}
      >
        {dropdownDataList?.map((setting: any) => {
          let valueSetting
          let valueDisplay
          const dynamicValue = valueType != undefined ? valueType : 'id';
          valueSetting = setting?.[dynamicValue]?.toString();

          switch (valueDescription) {
            case 'settingDescription':
              valueDisplay = setting?.settingDescription?.toString()
              break
            default:
              valueDisplay = setting?.settingName?.toString()
              break
          }

          return (
            <option key={valueSetting} value={valueSetting}>
              {valueDisplay}
            </option>
          )
        })}
      </select>
    )
  }

  const listItems =
    formik.values.companyFields && formik.values.companyFields.length > 0 ? (
      formik.values.companyFields?.map((companyField: CompanyFields, index: number) => {
        const isTheSetting =
          formik.getFieldProps('companyFields[' + index + '].settingName').value === settingName
        var dropdownDataList = currentInstanceSettings
          ? currentInstanceSettings[dropdownData as keyof typeof currentInstanceSettings]
          : []
        var label = hideLabel
          ? ''
          : formik.getFieldProps('companyFields[' + index + '].settingDescription').value
        if (isTheSetting) {
          return (
            <>
              {verticalLabel ? (
                <a.AncientFormWrapVertical displayText={label}>
                  {dropdown(dropdownDataList, index)}
                </a.AncientFormWrapVertical>
              ) : (
                <a.AncientFormWrapHorizontal displayText={label}>
                  {dropdown(dropdownDataList, index)}
                </a.AncientFormWrapHorizontal>
              )}
            </>
          )
        } else {
          return null
        }
      })
    ) : (
      <></>
    )

  return listItems
}
